import { useState } from "react";
import { apiPost } from "../lib/api";
import { BRAND } from "../lib/brand";
import { SartellLogo } from "../components/Logo";
import { TeamBadge } from "../components/TeamBadge";

/* ───────────────────── LOGIN SCREEN ───────────────────── */
export function LoginScreen({ team, onLogin, onBack }) {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!passcode.trim()) return;
    setLoading(true);
    setError("");
    try {
      const data = await apiPost("/auth", { teamId: team.id, passcode: passcode.trim() });
      onLogin(data);
    } catch (e) {
      setError(e.message || "Invalid passcode");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <SartellLogo size="lg" />
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
          <button onClick={onBack} className="text-sm hover:text-blue-600 mb-4 flex items-center gap-1" style={{ color: BRAND.accent }}>
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to teams
          </button>

          <div className="flex justify-center mb-3">
            <TeamBadge team={team} size="lg" />
          </div>
          <h2 className="text-xl font-bold text-gray-800 text-center">{team.name}</h2>
          <p className="text-sm text-gray-500 text-center mb-6">{team.ageGroup}{team.ageGroup && " · "}{team.season}</p>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Team Passcode</label>
              <input
                type="password"
                placeholder="Enter passcode..."
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                autoFocus
              />
              <p className="text-xs text-gray-400 mt-1">Parent passcode to mark availability. Coach passcode for full team view.</p>
            </div>

            {error && <p className="text-sm text-red-500 text-center">{error}</p>}

            <button
              onClick={handleLogin}
              disabled={loading}
              className="w-full py-3 text-white font-semibold rounded-xl transition-colors shadow-sm disabled:opacity-50"
              style={{ backgroundColor: BRAND.primary }}
              >
              {loading ? "Signing in..." : "Continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
